
<!-- App Loader -->
<div class="app-loading" *ngIf="loader" role="status" aria-live="polite"
   aria-label="Loading Tax Suite">
   <div class="logo"></div>
   <div class="separator"></div>
   <h3>Abogados</h3>
   <h5>Tax Suite</h5>
   <svg class="spinner" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
   </svg>
</div>

<router-outlet *ngIf="!loader"></router-outlet>
